module.exports = __webpack_public_path__ + "img/EOSM290.ffdf4084.png";